import { queryOptions } from '@tanstack/react-query'

import { fetchGlobalConfig } from './global-config-api'

export const globalConfigKeys = {
  all: ['admin-global-config'] as const,
  detail: () => [...globalConfigKeys.all, 'detail'] as const,
}

export const globalConfigQuery = () =>
  queryOptions({
    queryKey: globalConfigKeys.detail(),
    queryFn: ({ signal }) => fetchGlobalConfig(signal),
  })
